// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609291834/js/" + chunkId + "." + {"44":"4c25a202","225":"1b04fe29","481":"70728655","486":"da372c38","770":"4665a158"}[chunkId] + ".0.5467505340825418.chunk.js";
};